import { render, staticRenderFns } from "./activity-device-view.vue?vue&type=template&id=5b063b20&scoped=true&"
import script from "./activity-device-view.vue?vue&type=script&lang=js&"
export * from "./activity-device-view.vue?vue&type=script&lang=js&"
import style0 from "./activity-device-view.vue?vue&type=style&index=0&id=5b063b20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b063b20",
  null
  
)

component.options.__file = "activity-device-view.vue"
export default component.exports